import { ReactNode } from 'react'

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { Controller } from 'react-hook-form'

import { DATE_TIME_FORMAT } from 'constants/index'

interface IProps {
  control: any
  name: string
  label?: ReactNode
  defaultValue?: any
  variant?: 'standard' | 'filled' | 'outlined'
  required?: boolean
  size?: 'small' | 'medium'
  fullWidth?: boolean
  disabled?: boolean
  autoComplete?: string
  disablePast?: boolean
  minDateTime?: Date
  error?: any
  helperText?: any
}

const ControlledDateTimePicker = (props: IProps) => {
  const {
    control,
    name,
    defaultValue = '',
    variant,
    required,
    size,
    fullWidth = true,
    error,
    helperText,
    ...otherProps
  } = props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { ref, ...restField } }) => (
        <DateTimePicker
          {...restField}
          inputRef={ref}
          format={DATE_TIME_FORMAT}
          value={restField.value ? new Date(restField.value) : null}
          timeSteps={{ minutes: 2 }}
          slotProps={{
            textField: {
              variant: variant,
              fullWidth: fullWidth,
              required: required,
              size: size,
              error: error,
              helperText: helperText,
            },
          }}
          {...otherProps}
        />
      )}
    />
  )
}

export default ControlledDateTimePicker
